import { apiClient } from '@/api/client'
import type {
  SendMessageRequest,
  AdminMessage,
  AdminMessageListItem,
  AdminMessageDetail,
  MessageStats,
  ReceivedMessage,
  ReceivedMessageList,
  UnreadCount
} from '../types/message'

// ===== Admin API =====

export const adminMessageApi = {
  /**
   * 메시지 발송
   */
  sendMessage: async (request: SendMessageRequest): Promise<AdminMessage> => {
    const response = await apiClient.post('/organization/messages', request)
    return response.data.data
  },

  /**
   * 발송 내역 목록
   */
  getMessageList: async (page = 0, size = 20): Promise<{ content: AdminMessageListItem[], totalPages: number }> => {
    const response = await apiClient.get('/organization/messages', {
      params: { page, size }
    })
    return response.data.data
  },

  /**
   * 메시지 상세 + 읽음 현황
   */
  getMessageDetail: async (messageId: number): Promise<AdminMessageDetail> => {
    const response = await apiClient.get(`/organization/messages/${messageId}`)
    return response.data.data
  },

  /**
   * 읽음 통계
   */
  getMessageStats: async (messageId: number): Promise<MessageStats> => {
    const response = await apiClient.get(`/organization/messages/${messageId}/stats`)
    return response.data.data
  }
}

// ===== Learner API =====

export const learnerMessageApi = {
  /**
   * 받은 메시지 목록
   */
  getMessages: async (page = 0, size = 20): Promise<ReceivedMessageList> => {
    const response = await apiClient.get('/my/messages', {
      params: { page, size }
    })
    return response.data.data
  },

  /**
   * 메시지 상세 (읽음 처리)
   */
  getMessageDetail: async (messageId: number): Promise<ReceivedMessage> => {
    const response = await apiClient.get(`/my/messages/${messageId}`)
    return response.data.data
  },

  /**
   * 읽지 않은 메시지 수
   */
  getUnreadCount: async (): Promise<UnreadCount> => {
    const response = await apiClient.get('/my/messages/unread-count')
    return response.data.data
  }
}
